var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyLeak({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 93,
    viewBox: "0 0 95 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M95 46H38V29h52.721zM20 2v9H2V0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M39 48H23C10.297 48 0 37.703 0 25V10h22v11a6 6 0 006 6h11v21z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M38.5 47.5v-20H28a6.5 6.5 0 01-6.5-6.5V10.5H.5V25C.5 37.426 10.574 47.5 23 47.5h15.5zM2.5 10.536V.5m17 9v-7m19.163 43H94.5m-55.83-16H90.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke-alt",
    d: "M54.5 47.5l-9 18m-2 3l-2 5m13-19l-3 18m5-21l3 13m-1-15l12 22m2 3l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M62.929 78.458a3.85 3.85 0 003.122-4.46c-.246-1.395-1.987-3.88-5.223-7.455-1.818 4.466-2.604 7.397-2.358 8.792a3.85 3.85 0 004.459 3.123z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M60.992 67.476c-1.568 3.957-2.24 6.579-2.03 7.772a3.35 3.35 0 006.597-1.163c-.21-1.193-1.74-3.427-4.567-6.61z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M60.892 92.45a3.5 3.5 0 003.115-3.846c-.134-1.282-1.556-3.647-4.265-7.094-1.932 3.935-2.831 6.544-2.696 7.825a3.5 3.5 0 003.846 3.115z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M59.841 82.452c-1.647 3.445-2.411 5.753-2.298 6.831a3 3 0 105.967-.627c-.113-1.078-1.34-3.176-3.669-6.204z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M49.232 86.674a3.87 3.87 0 004.429-3.217c.223-1.408-.62-4.34-2.526-8.798-3.19 3.65-4.897 6.18-5.12 7.587a3.87 3.87 0 003.217 4.428z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M50.987 75.594c-2.788 3.251-4.287 5.525-4.478 6.73a3.37 3.37 0 106.658 1.055c.19-1.205-.532-3.831-2.18-7.785z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M57.451 45.688l-2.618-3.411 5.729-2.151-2.865-3.457"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyLeak);
export default __webpack_public_path__ + "static/media/EmergencyLeak.a181284ff5cb125662360edc188bade6.svg";
export { ForwardRef as ReactComponent };